module.exports = __webpack_public_path__ + "static/img/e-banner-m1.c2f341b9.jpg";